export default __webpack_public_path__ + "static/media/zidaneProfile.7b69b35c.png";